import { useTranslation } from "@sagot/i18n";
import { Button, Icon, useTheme } from "@sagot/ui";

/**
 * Light / dark switch of the auth shell (the mockup's round moon / sun button). It writes the console's own theme preference, so the
 * shell (`.auth-shell[data-theme]`, auth.css) and the shared controls inside it change together and the choice is kept (`sg-theme`).
 */
export function AuthThemeSwitch() {
  const { t } = useTranslation();
  const { resolved, setPreference } = useTheme();
  const dark = resolved === "dark";
  return (
    <Button
      variant="ghost"
      iconOnly
      aria-label={t("theme.toggle")}
      aria-pressed={dark}
      className="a-theme"
      onClick={() => {
        setPreference(dark ? "light" : "dark");
      }}
    >
      <Icon name={dark ? "sun" : "moon"} />
    </Button>
  );
}
